// components/SudokuVideo.tsx
import React from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuBasicsStyles/SudokuVideo.css';

const SudokuVsVideo = () => (
    <div className="tutorial-step-container">
        <div className="video-placeholder">
            <iframe
                src="https://www.youtube.com/embed/Cf29vw-yrHw"
                title="Sudoku Tutorial Video"
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
                className="video-iframe fullscreen-video"
            />

        </div>
    </div>
);

export default SudokuVsVideo;